export enum Page {
	Home = "home",
	Swagger = "swagger"
}

export enum BooleanString {
	True = "true",
	False = "false"
}